export default "__VITE_ASSET__qZlgKAsC__"